function make_taggable() {

	//Binding an event to update values for updation / creation
	$('[taggables]').closest('form').on('submit', function(){
		$('.tag-link').click();
		$('[taggables]').each(function(i, taggable) {
			var taggable_field = $("#" + $(taggable).attr('taggable_field'));
			if ( taggable_field.length > 0 ) {
				if ( $(taggable).attr('is_hash') !== undefined && $(taggable).attr('is_hash').length > 0 ) {
					var tag_words = {};
					$(taggable).find('ul.tag-list').children().each(function(index, tag_list){
						var tag_split = $(tag_list).find('span').html().split(",");
						tag_words[ $.trim(tag_split[0]) ] = $.trim(tag_split[1]);
					});
					$(taggable_field).val( JSON.stringify(tag_words) );
				} else {
					var taggable_words = [];
					$(taggable).find('ul.tag-list').children().each(function(index, tag_list){
						taggable_words.push( $(tag_list).find('span').html() );
					});
					$(taggable_field).val( taggable_words.join(',') );
				}
			}
		});
	});

	$('.tag-input select').on('change', function() {
		enable_tag_link($(this));
	});

	$('.tag-input input[type="text"]').on('keyup', function() {
		enable_tag_link($(this));
	});


	$(document).on('click', '.tag-link', function() {
		var taggable = $(this).closest('[taggables]');
		var limit = $(taggable).attr('limit');
		var tag_element = '<div class="tag pt-pill has-tip noborder" data-tooltip="" title=""><span></span><i class="pti pt-close remove-tag"></i></div>';
		var tag_words = [];
		var multiple_tag_words = [];

		if($(taggable).find('.tag-input').find('input[type=text]').length > 1){
			$(taggable).find('.tag-input').find('input').each(function(index, element) {
				value = $.trim($(element).val())
				if ( value !== "" ) {
					multiple_tag_words.push(value);
				}
				$(element).val('');
			});
		}
		else{
			$(taggable).find('.tag-input').find('input').each(function(index, element) {
				var all_elements = $(element).val().split(",");
				$.each( all_elements, function( i, val ) {
					if ( $.trim(val) !== "" ) {
						tag_words.push(val);
					}
				});
				$(element).val('');
			});
		}


		var select_field_word = [];
		$(taggable).find('.tag-input').find('select').each(function(index, element) {
			if ( $(element).val() !== "" ) {
				select_field_word.push( $(element).val() );
				$(element).val('');
			}
		});

		if ( (tag_words.join(', ') !== "" || multiple_tag_words.join(', ') !== "" || select_field_word.join(', ') !== "") && $(taggable).find('ul.tag-list').children().length < limit) {
			$.each( tag_words, function(i, val ) {
				$(taggable).find('ul.tag-list').append('<li class="tag-element">' + tag_element + '</li>');
				$(taggable).find('ul.tag-list').children().eq(-1).find('.tag').attr('title', $.trim(val) );
				$(taggable).find('ul.tag-list').children().eq(-1).find('.tag span').html( $.trim(val) );
			});

			if ( select_field_word.join(', ') !== "" && select_field_word.length > 1) {
				$(taggable).find('ul.tag-list').append('<li class="tag-element">' + tag_element + '</li>');
				$(taggable).find('ul.tag-list').children().eq(-1).find('.tag').attr('title', select_field_word.join(', '));
				$(taggable).find('ul.tag-list').children().eq(-1).find('.tag span').html(select_field_word.join(', '));
			}

			$('.remove-tag').unbind('click');
			$(document).on('click', '.remove-tag', function() {
				$(this).closest('.tag-element').remove();

				if($($('.tag-input').find('input, select').not("input[id^='s2id_autogen']")[0]).data('select2')){
					updateSelect2Data();
				}
			});

			$(this).addClass('disabled');
			$(this).removeClass('pt-blue');
		}

		if (multiple_tag_words.length > 1){
			$(taggable).find('ul.tag-list').append('<li class="tag-element">' + tag_element + '</li>');
			$(taggable).find('ul.tag-list').children().eq(-1).find('.tag').attr('title', multiple_tag_words.join(', '));
			$(taggable).find('ul.tag-list').children().eq(-1).find('.tag span').html(multiple_tag_words.join(', '));
		}

		if($($('.tag-input').find('input, select').not("input[id^='s2id_autogen']")[0]).data('select2')){
			updateSelect2Data();
		}

	});

	//Make tags for Hash values
	$('[taggables][is_hash]').each(function(i, taggable) {
		var taggable_field = $(taggable).find( "#" + $(taggable).attr('taggable_field') );
		var taggable_field_hash = $.parseJSON( $(taggable_field).val() );
		if (taggable_field_hash !== null) {
			$.each( taggable_field_hash, function( key, value ) {
				$(taggable).find('.tag-input').find('input').eq(0).val(key);
				$(taggable).find('.tag-input').find('input').eq(1).val(value);
				$(taggable).find('.tag-input').find('select').eq(0).val(key);
				$(taggable).find('.tag-input').find('select').eq(1).val(value);
				$('.tag-link').click();
			});
			$(taggable).find('.tag-input').find('select').eq(0).val('');
			$(taggable).find('.tag-input').find('select').eq(1).val('');
			$(taggable).find('.tag-input').find('input').eq(0).val('');
			$(taggable).find('.tag-input').find('input').eq(1).val('');
		}
	});

	//Make Tags when rendered
	$('.tag-link').click();
}

function enable_tag_link(clicked_link) {
	var new_tag_word = true;
	$(clicked_link).closest('.tag-input').find('input, select').not("input[id^='s2id_autogen']").each(function(index, element) {
		if( $(element).val() === '') {
			new_tag_word = false;
		}
	});
	tag_link = $(clicked_link).closest('[taggables]').find('.tag-link')
	if ( new_tag_word ) {
		tag_link.addClass('pt-blue');
		tag_link.removeClass('disabled');
	} else {
		tag_link.addClass('disabled');
		tag_link.removeClass('pt-blue');
	}
}

function updateSelect2Data(){
	var obj_name = $('.tag-input').find("[data-values]").attr('id');
	var obj = $('#' + obj_name);
	obj.select2('destroy');

	makeAspectsNameAutocomplete(obj);
}

// Filter already selected tags
function filteredOptions(obj){
	var options = [], already_selected_tags=selectedTags();
	if(already_selected_tags.length > 0){
		$.each(obj.data('values'), function(index, opt){
			if($.inArray(opt.text, already_selected_tags) < 0){
				options.push(opt);
			}
		})
	}
	else{
		options = obj.data('values')
	}

	return options
}

// list of all the selected tags
function selectedTags(){
  var selected_attributes = [];

  $('#tag_list').find('.tag-element').each(function(index, element){
  	selected_attributes.push($(element).find('span').html().split(',')[0]);
  })

  return selected_attributes;
};


function makeAspectsNameAutocomplete(obj) {
	obj.select2({
	  createSearchChoice: function(term, data) {
	    if ($(data).filter((function() {
	      return this.text.localeCompare(term) === 0;
	    })).length === 0) {
	      return {
	        id: term,
	        text: term
	      };
	    }
	  },
	  separator: ',',
	  multiple: false,
	  data: {
	    results: filteredOptions(obj)
	  }
	});
}

// Expose to window so other esbuild modules can call these as globals
// (in the old Sprockets pipeline these were all in shared global scope)
window.make_taggable = make_taggable;
window.enable_tag_link = enable_tag_link;
window.updateSelect2Data = updateSelect2Data;
window.filteredOptions = filteredOptions;
window.selectedTags = selectedTags;
window.makeAspectsNameAutocomplete = makeAspectsNameAutocomplete;
